import { ChangeDetectionStrategy, Component, EventEmitter, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dial-number',
  standalone: true,
  imports: [FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, TranslateModule, MatIconModule],
  template: `
    <div class="custom-context-menu-wrapper no-subscript d-flex flex-column gap-2 p-2 mb-2">
      <mat-form-field class="mt-2" appearance="fill">
        <mat-icon matPrefix>phone</mat-icon>
        <input matInput [ngModel]="phoneNumber()" (ngModelChange)="phoneNumber.set($event)" placeholder="(555) 555-5555" />
      </mat-form-field>
      <button mat-flat-button color="primary" (click)="dial.emit(phoneNumber())" [disabled]="!phoneNumber().trim()">
        {{ 'VideoCall.Dialer.Dial' | translate }}
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialNumberComponent {
  phoneNumber = signal('');
  @Output() dial = new EventEmitter<string>();
}
